// LANDING-MAY26-1 — single source of truth for the May 2026 25%-off
// campaign. All landing-page copy, the discounted price, and the auto-hide
// cutoff live here so retiring the campaign is a one-file change (or just
// waiting until the cutoff passes).
//
// Out of scope: checkout, Stripe, discount_codes, SetupPayment, SEO meta,
// BelowFold pricing. The MAY26 code already exists in `discount_codes` and
// is applied at checkout via the existing redemption flow.
import { FULL_PRICE_PENCE, formatGBP } from "@/lib/pricing";

export const CAMPAIGN_CODE = "MAY26";
export const CAMPAIGN_PERCENT_OFF = 25;

// 31 May 2026 23:59:59.999 BST → 1 June 2026 00:00 BST = 23:00 UTC on
// 31 May. Encoded as UTC so the cutoff is identical for every visitor.
const CAMPAIGN_END_MS = Date.UTC(2026, 4, 31, 23, 0, 0); // months are 0-indexed

export function isCampaignActive(now: number = Date.now()): boolean {
  return now < CAMPAIGN_END_MS;
}

export function discountedPence(fullPence: number = FULL_PRICE_PENCE): number {
  return Math.round((fullPence * (100 - CAMPAIGN_PERCENT_OFF)) / 100);
}

export const CAMPAIGN_DISCOUNTED_PRICE_LABEL = formatGBP(discountedPence());
export const CAMPAIGN_FULL_PRICE_LABEL = formatGBP(FULL_PRICE_PENCE);

// Copy strings — keep them here so the wording is consistent across the
// promo bar, hero eyebrow, hero pricing line, and sticky mobile CTA.
export const CAMPAIGN_COPY = {
  promoBarLeading: "May 26 only: 25% off Confetti Cam",
  promoBarMobileShort: "May 26 only: 25% off",
  promoBarUseCode: "Use code",
  promoBarEnds: "Ends 31 May 2026",
  promoBarMobileTail: "Use code MAY26 — ends 31 May 2026",
  heroEyebrow: "MAY 26 OFFER ENDS 31 MAY 2026",
  heroCtaLabel: "Create your wedding game — save 25%",
  heroChipPrice: `${CAMPAIGN_DISCOUNTED_PRICE_LABEL} one-off`,
  stickyTitle: "Save 25% — code MAY26",
  stickySubtitle: `${CAMPAIGN_DISCOUNTED_PRICE_LABEL} · usually ${CAMPAIGN_FULL_PRICE_LABEL}`,
} as const;
